import React, { useEffect } from 'react';
import { useSmoothScroll } from '../hooks/useSmoothScroll';
import { useScrollAnimations } from '../hooks/useScrollAnimations';
import PageShell from '../components/PageShell';
import Hero from '../components/Hero';
import ValorDigital from '../components/ValorDigital';
import Servicos from '../components/Servicos';
import Projetos from '../components/Projetos';
import Resultados from '../components/Resultados';
import Depoimentos from '../components/Depoimentos';
import ComoTrabalho from '../components/ComoTrabalho';
import Sobre from '../components/Sobre';
import FAQ from '../components/FAQ';
import Contato from '../components/Contato';

const Home = () => {
  useSmoothScroll();
  useScrollAnimations();

  useEffect(() => {
    document.documentElement.classList.add('preload');
    const timer = setTimeout(() => {
      document.documentElement.classList.remove('preload');
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!window.location.hash) return;

    const scrollToHash = () => {
      const element = document.querySelector(window.location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const timer = setTimeout(scrollToHash, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <PageShell>
      <Hero />
      <ValorDigital />
      <Servicos />
      <Projetos />
      <Resultados />
      <Depoimentos />
      <ComoTrabalho />
      <Sobre />
      <FAQ />
      <Contato />
    </PageShell>
  );
};

export default Home;
